import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import Products from '../../Models/Products';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Common from "../../Models/Common";
class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            collapse: false,
            modal: false,
            sellerDetails: [],
            lastLoginTime: '',
            sellerid: '',
        };
        // this.getlastLogin(this.props.id)
        this.getSellerDetails(this.props.id)
        this.getSellerDetailsId();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getSellerDetails(id) {
        Products.getProductsDetails(id).then(res => {
            this.setState({ sellerDetails: res.data.seller })
        })
    }
    getSellerDetailsId() {
        Products.getProductsDetails(this.props.id).then(res => {
            res.data.seller.map(res =>
                this.setState({ sellerid: res.id })
            )
        })
    }

    // getlastLogin(id) {
    //     Products.getProductsDetails(id).then(res => {
    //         this.setState({ lastLoginTime: res.data.hours_since_last_login })
    //     })
    // }
    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    toggleAll() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    sellerName(name, id) {
        if (!localStorage.getItem('info')) {
            return (
                <div className="">
                    <div style={{ textAlign: 'center', fontSize: '13px', textDecoration: 'none', cursor: 'pointer' }} className="mt-2 " onClick={this.toggleAll.bind(this)}>{name}</div>
                    <Modal isOpen={this.state.modal} toggle={this.toggleAll.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggleAll.bind(this)}></ModalHeader>
                        <ModalBody>
                            {this.props.t('0')}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggleAll.bind(this)}>{this.props.t('9')}</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        } else {
            return (
                <div className="">
                    <Link to={{ pathname: `/my-profile-view/users/${id}`, state: { id: id } }} style={{ textAlign: 'center', fontSize: '13px', textDecoration: 'none' }} className="mt-2 ">
                        {name}
                    </Link></div>
            )
        }
    }

    details(details) {
        if (details === null || details === '') {
            return (
                <div>
                    <span>{details}
                        <span id="dots"></span> <br /> <Collapse isOpen={this.state.collapse}>{details}</Collapse></span>
                    {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>{this.props.t('5')}</div> */}
                    {this.onRead(details)}
                </div>
            )
        } else {
            return (
                <div>
                    <span>{details.substr(0, 50)}</span>
                    {/* <span id="dots"></span> <br /> <Collapse isOpen={this.state.collapse}>{details.substr(51, 1000)}</Collapse></span> */}
                    {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>{this.props.t('5')}</div> */}
                    {/* {this.onRead(details)} */}
                </div>
            )
        }
    }

    onRead(details) {
        if (details === null || details === '') {
            return (
                <div className=""></div>
            )
        } else {
            const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
            if (this.state.collapse === true) {
                if (details !== null) {
                    return (
                        <div onClick={this.toggle.bind(this)} style={{ cursor: 'pointer', border: '0px solid' }} className="card">
                            <Collapse isOpen={this.state.collapse} >
                                {details.split('\n').map(function (item, key) {
                                    return (
                                        <span key={key}>
                                            {item}
                                            <br />
                                        </span>
                                    )
                                })}
                            </Collapse>
                            <i className="fas fa-angle-up"></i>
                        </div>
                    )
                } else {
                    return (
                        <div className=""></div>
                    )
                }
            } else {
                return (
                    <div onClick={this.toggle.bind(this)} className="card" style={{ cursor: 'pointer', border: '0px solid' }}>
                        {/* {renderHTML(details.substr(0, 50))} */}
                        {details.substr(0,120).split('\n').map(function (item, key) {
                            return (
                                <span key={key}>
                                    {item}
                                    <br />
                                </span>
                            )
                        })}
                        {this.props.t('5')}
                </div>
                )
            }
        }
        //}
        // if (this.state.collapse === true) {
        //     return (<div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem', cursor: 'pointer' }}><i className="fas fa-angle-up"></i></div>
        //     )
        // } else {
        //     return (<div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem', cursor: 'pointer' }}>{this.props.t('5')}</div>
        //     )
        // }
    }

    contractProfile(id) {
        if (localStorage.getItem('info')) {
            let x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: "/affiliator-direct-message" + "/" + encodeURIComponent(x.id + "&" + id),
                        state: {
                            buyer_id: x.id,
                            seller_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <div style={{ textAlign: "center", fontSize: "13px" }}> {this.props.t('1')}</div>
                    </Link >
                )
            } else if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: '/buyer-direct-message' + "/" + encodeURIComponent(x.id + "&" + id),
                        state: {
                            buyer_id: x.id,
                            seller_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <div style={{ textAlign: "center", fontSize: "13px" }}> {this.props.t('1')}</div>
                    </Link >
                )
            } else if (x.user_type_id === 2 && x.id !== id) {
                return (
                    <Link to={{
                        // pathname: '/seller-chat-initiation'+"/"+encodeURIComponent(x.id+"&"+id),
                        pathname: '/seller-direct-message',
                        state: {
                            buyer_id: x.id,
                            seller_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <div style={{ textAlign: "center", fontSize: "13px" }}> {this.props.t('1')}</div>
                    </Link >
                )
            }
        }
    }

    render() {
        return (
            <div className="mt-3 ">
                <div className="cart_inner p-2">
                    <div className="cart_option">
                        <div className="payment_price">
                            <strong>
                                <b>{this.props.t('4')}</b>
                            </strong>
                        </div>
                        {this.state.sellerDetails.map(seller =>
                            <div key={seller.id} className='row'>
                                {/* <div className="col-md-2"></div> */}
                                <div className="col-md-12">
                                    <div className="text-center" style={{ textDecoration: 'none' }}>
                                        <img src={Common.baseUrl + seller.img} alt="" className="rounded-circle p-2 " height="100" width="100" style={{ marginLeft: '0px', objectFit: 'cover' }} />
                                    </div>
                                    <div className="text-center">
                                        {this.sellerName(seller.first_name, seller.id)}
                                    </div>
                                    <div style={{ textAlign: "center", fontSize: "13px" }}> {seller.sex_text}</div>
                                    {this.contractProfile(seller.id)}
                                    <div className="pl-1">
                                        {/* <p>
                                            <font style={{ verticalAlign: 'inherit', marginBottom: '2px' }}>
                                                {seller.profession}
                                            </font>
                                        </p> */}
                                        <div>
                                            {this.onRead(seller.personal_details)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
export { Profile }


 Profile = withTranslation('src_Components_CategoriesDetails_Profile')(Profile);